import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { InspectionService } from '../../shared/services/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './edit-json.component.html',
    standalone: false
})
export class InspectionEditJsonPageComponent extends BaseModalPageComponent implements OnInit {
  inspection: any;
  inspectionId: string;
  public processing = false;

  constructor(
    public inspectionService: InspectionService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;
      this.initData();
    });
  }

  saveInspection(object: any): void {
    this.processing = true;
    this.inspectionService.updateInspectionEntity(object).subscribe((res) => {
      this.goToBack();
    });
  }

  cancel(): void {
    this.goToBack();
  }

  initData(): void {
    this.inspectionService.getInspectionEntity(this.inspectionId).subscribe((el) => {
      this.inspection = el;
      this.cdf.detectChanges();
    });
  }
}
